// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.user_title__Y6Cly {
  font-weight: 700;
  font-size: 3rem;
}

.user_search-user__RwMkc {
  padding: 10px 50px 10px 5px;
  font-size: 1.6rem;
}
.user_search-user__RwMkc:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important;
  border-color: #6c757d;
}

.user_add-btn__XcVMQ {
  font-size: 1.6rem;
  border-radius: 8px;
  margin-top: 20px;
}

.user_btn-category__Iw0Ew {
  font-size: 1.2rem;
  padding: 3px 10px !important;
}

.user_input-cate__Db1Sz {
  background: transparent !important;
  border: none !important;
  outline: none !important;
}

.user_wrapper__N6txV {
  display: flex;
}

.user_content-wrap__i4opF {
  word-wrap: break-word; /* Cho phép nội dung tự động xuống dòng */
  overflow-wrap: break-word; /* Hỗ trợ cho trình duyệt mới */
  white-space: normal; /* Không giữ nội dung trên cùng một dòng */
}

@media (max-width: 1024px) {
  .user_wrapper__N6txV {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/Admin/user/user.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,gBAAA;EACA,eAAA;AAEJ;;AAAA;EACI,2BAAA;EACA,iBAAA;AAGJ;AADI;EACI,aAAA;EACA,4DAAA;EACA,qBAAA;AAGR;;AAAA;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;AAGJ;;AADA;EACI,iBAAA;EACA,4BAAA;AAIJ;;AAFA;EACI,kCAAA;EACF,uBAAA;EACA,wBAAA;AAKF;;AAHA;EACI,aAAA;AAMJ;;AAJA;EACI,qBAAA,EAAA,yCAAA;EACA,yBAAA,EAAA,+BAAA;EACA,mBAAA,EAAA,0CAAA;AAOJ;;AAEA;EACI;IACI,cAAA;EACN;AACF","sourcesContent":[".title{\n    font-weight: 700;\n    font-size: 3rem;\n}\n.search-user{\n    padding: 10px 50px 10px 5px;\n    font-size: 1.6rem;\n    \n    &:focus{\n        outline: none;\n        box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important; \n        border-color: #6c757d;\n  }\n}\n.add-btn{\n    font-size: 1.6rem;\n    border-radius: 8px;\n    margin-top: 20px;\n}\n.btn-category{\n    font-size: 1.2rem;\n    padding: 3px 10px !important;\n}\n.input-cate{\n    background: transparent !important; \n  border: none !important; \n  outline: none !important;\n}\n.wrapper{\n    display: flex;\n}\n.content-wrap {\n    word-wrap: break-word;     /* Cho phép nội dung tự động xuống dòng */\n    overflow-wrap: break-word; /* Hỗ trợ cho trình duyệt mới */\n    white-space: normal;       /* Không giữ nội dung trên cùng một dòng */\n  }\np{\n    // margin-left: 0 !important;\n}\n\n  \n  \n\n@media (max-width: 1024px) {\n    .wrapper{\n        display: block;\n\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `user_title__Y6Cly`,
	"search-user": `user_search-user__RwMkc`,
	"add-btn": `user_add-btn__XcVMQ`,
	"btn-category": `user_btn-category__Iw0Ew`,
	"input-cate": `user_input-cate__Db1Sz`,
	"wrapper": `user_wrapper__N6txV`,
	"content-wrap": `user_content-wrap__i4opF`
};
export default ___CSS_LOADER_EXPORT___;
